import { isDebugMode } from './isDebugMode';
export interface ExpressionError {
  error: {
    name: string;
    message: string;
  };
}

export const isExpressionError = (view: any): view is ExpressionError =>
  isDebugMode() &&
  view != null &&
  !Array.isArray(view) &&
  typeof view === 'object' &&
  typeof view.error?.name === 'string' &&
  typeof view.error?.message === 'string';
